import React, { FC } from 'react';

import { Container } from 'layout';

import { useElasticContext } from '../../../contexts/elasticContext';
import { CustomPoliciesAndReportsHitsProps } from './models';
import PoliciesAndReportsItem from './PoliciesAndReportsItem';

import './CustomPoliciesAndReportsHits.scss';

const CustomPoliciesAndReportsHits: FC<CustomPoliciesAndReportsHitsProps> = ({
  loadMoreText,
  viewPageLinkText,
  pdfDownloadLinkText,
}) => {
  const { dataHits, loadMore, handleLoadMoreHits } = useElasticContext();

  return (
    <div className="policies-and-reports">
      <Container>
        <ul className="policies-and-reports__list">
          {dataHits?.map((hit) => (
            <li className="policies-and-reports__item" key={hit._id}>
              <PoliciesAndReportsItem
                hit={hit}
                viewPageLinkText={viewPageLinkText}
                pdfDownloadLinkText={pdfDownloadLinkText}
              />
            </li>
          ))}
        </ul>
        <button
          type="button"
          className="policies-and-reports__more-btn btn btn--primary btn--pink"
          onClick={handleLoadMoreHits}
          disabled={!loadMore}
        >
          {loadMoreText}
        </button>
      </Container>
    </div>
  );
};

export default CustomPoliciesAndReportsHits;
